import { EpimsBaseEntityDto } from './epim-base.dto';

export class RightHeldDto extends EpimsBaseEntityDto {

    RightHeldId: string;

    RightHeldName: string;
    SubscriberId: string;
    SubscriptionUserId: string;
}